module.exports = ".map{height:85vh}\n"